import React from 'react';

interface IMarginGroupProps {
  margin: { top: number; right?: number; bottom?: number; left: number };
  children: any;
}
/**
 * Render a transformed margin group as per D3.js margin conventions.
 * @param {object} props React prop
 * @param {object} props.margin D3.js conventional margin object
 * @param {array|element} props.children React children
 */
export const MarginGroup = React.memo(
  (props: IMarginGroupProps): JSX.Element => {
    const { margin, children } = props;

    return (
      <g transform={`translate(${margin.left}, ${margin.top})`}>{children}</g>
    );
  }
);

MarginGroup.displayName = 'MarginGroup';
